const { createAction } = require('../helpers')

const {
  GET_CERTIFICATE_INFO,
  GET_CERTIFICATE_INFO_SUCCESS,
  GET_CERTIFICATE_INFO_ERROR,
  GET_CERTIFICATE_INFO_RESET,
} = require('./constants')

const getCertificateInfo = certData => createAction(GET_CERTIFICATE_INFO, { certData })
const getCertificateInfoSuccess = data => createAction(GET_CERTIFICATE_INFO_SUCCESS, { data })
const getCertificateInfoError = error => createAction(GET_CERTIFICATE_INFO_ERROR, { error })
const getCertificateInfoReset = () => createAction(GET_CERTIFICATE_INFO_RESET)

module.exports = {
  getCertificateInfo,
  getCertificateInfoSuccess,
  getCertificateInfoError,
  getCertificateInfoReset,
}
